export default "__VITE_ASSET__4e0eaef0__"